// src/services/productionRecordsApi.js
import apiService from './apiService';

const productionRecordsApi = {
  getAll: (params = {}) => apiService.get('/production-records', { params }),
  getForDevice: (deviceId) => apiService.get(`/production-records/device/${deviceId}`),
  getTrend: (deviceId) => apiService.get(`/production-records/trend/${deviceId}`),
  create: (data) => apiService.post('/production-records', data),
  syncMortality: (deviceId) => apiService.post(`/production-records/sync-mortality/${deviceId}`),
  getMortalityEvents: (deviceId) => apiService.get(`/production-records/mortality-events/${deviceId}`),
};

export default productionRecordsApi;
